import { connect } from 'react-redux';
import HeaderBar from '../component/headerBarComponent';

const mapStateToProps = (state) => ({
    headerBarTitle: state.app.headerBarTitle,
    headerBarText: state.app.headerBarText,
    headerBarLink: state.app.headerBarLink,
    headerBarStartColor: state.app.headerBarStartColor,
    headerBarEndColor: state.app.headerBarEndColor,
});

// passing an empty object for mapDispatchToProps to avoid dispatch being passed on and causing prop-types-exact to complain
const headerBarContainer = connect(
    mapStateToProps,
    {},
)(HeaderBar);

export default headerBarContainer;
